/* =====================================================================
   by Crea - consent banner, Direction A (editorial sheet)
   Paste inside <script> tags, or add as a theme asset.
   Pairs with by-crea-consent-banner.css

   Country, language and currency come from window.Shopify.country,
   .locale and .currency - NOT from the URL. by Crea has nine markets and
   the EU market serves 25 countries from one storefront, so URL matching
   could never give Portugal, Austria, Belgium etc. their own flag.

   CookieYes's own buttons are MOVED into the privacy column, never
   rebuilt, so all of its consent logic stays attached and untouched.
   ===================================================================== */

(function () {
  'use strict';

  /* ---------- copy, by locale (Shopify serves only en / de / fr / sv) ----------
     vatEU  : domestic EU/EEA sale — VAT in the price, shipping quoted at checkout.
     vatROW : export sale — duties, customs AND VAT prepaid. The second sentence is
              the point of the whole banner for those markets: it promises no
              customs invoice after delivery, which is the single biggest reason a
              US or Japanese shopper abandons a European furniture cart.          */
  var T = {
    en: { welcome:'Welcome to by Crea', currency:'Currency', price:'Price',
          shipping:'Shipping time', days:'2–5 days', daysSE:'2–3 days',
          global:'International',
          vatEU:'<strong>VAT included.</strong> Shipping calculated at checkout.',
          vatROW:'<strong>Import duties, customs charges and VAT included.</strong> ' +
                 'Nothing further to pay on delivery.',
          ptitle:'We value your privacy',
          ptext:'We use cookies to improve your experience, personalise content and analyse ' +
                'traffic. You can change this at any time in the ' +
                '<a href="/policies/privacy-policy">cookie policy</a>.',
          reject:'Reject all', prefs:'Cookie preferences', save:'Save my choices',
          intro:'Necessary cookies keep the site working and cannot be turned off. Everything ' +
                'else is your choice, and you can change it whenever you like.',
          cat:{ necessary:'Secure sign-in, your basket, and remembering the choices you make here.',
                functional:'Sharing to social platforms, collecting feedback, and other third-party features.',
                analytics:'How the site is used. Visitor numbers, traffic sources, which pages get read.',
                performance:'Speed and stability measures, used to make the site quicker and steadier.',
                advertisement:'Advertising based on pages you have visited, and whether a campaign worked.',
                other:'Cookies we have not finished classifying.' } },
    de: { welcome:'Willkommen bei by Crea', currency:'Währung', price:'Preis',
          shipping:'Lieferzeit', days:'2–5 Tage', daysSE:'2–3 Tage',
          global:'International',
          vatEU:'<strong>Inkl. MwSt.</strong> Versandkosten werden an der Kasse berechnet.',
          vatROW:'<strong>Einfuhrzölle, Zollgebühren und MwSt. enthalten.</strong> ' +
                 'Bei Lieferung fallen keine weiteren Kosten an.',
          ptitle:'Wir respektieren Ihre Privatsphäre',
          ptext:'Wir verwenden Cookies, um Ihr Erlebnis zu verbessern, Inhalte zu personalisieren ' +
                'und den Datenverkehr zu analysieren. Sie können dies jederzeit in der ' +
                '<a href="/policies/privacy-policy">Cookie-Richtlinie</a> ändern.',
          reject:'Alle ablehnen', prefs:'Cookie-Einstellungen', save:'Auswahl speichern',
          intro:'Notwendige Cookies halten die Website am Laufen und lassen sich nicht abschalten. ' +
                'Alles andere entscheiden Sie, und Sie können es jederzeit ändern.',
          cat:{ necessary:'Sichere Anmeldung, Ihr Warenkorb und die Auswahl, die Sie hier treffen.',
                functional:'Teilen in sozialen Netzwerken, Feedback und andere Funktionen von Drittanbietern.',
                analytics:'Wie die Website genutzt wird: Besucherzahlen, Herkunft, welche Seiten gelesen werden.',
                performance:'Messungen zu Geschwindigkeit und Stabilität, damit die Website schneller und zuverlässiger wird.',
                advertisement:'Werbung auf Grundlage besuchter Seiten, und ob eine Kampagne gewirkt hat.',
                other:'Cookies, die wir noch nicht zugeordnet haben.' } },
    fr: { welcome:'Bienvenue chez by Crea', currency:'Devise', price:'Prix',
          shipping:'Délai de livraison', days:'2 à 5 jours', daysSE:'2 à 3 jours',
          global:'International',
          vatEU:'<strong>TVA incluse.</strong> Frais de port calculés au paiement.',
          vatROW:'<strong>Droits de douane, frais d\'importation et TVA inclus.</strong> ' +
                 'Aucun frais supplémentaire à la livraison.',
          ptitle:'Nous respectons votre vie privée',
          ptext:'Nous utilisons des cookies pour améliorer votre expérience, personnaliser le ' +
                'contenu et analyser le trafic. Vous pouvez modifier ce choix à tout moment dans la ' +
                '<a href="/policies/privacy-policy">politique relative aux cookies</a>.',
          reject:'Tout refuser', prefs:'Préférences de cookies', save:'Enregistrer mes choix',
          intro:'Les cookies nécessaires font fonctionner le site et ne peuvent pas être désactivés. ' +
                'Pour tout le reste, c\'est vous qui choisissez, et vous pouvez changer d\'avis à tout moment.',
          cat:{ necessary:'Connexion sécurisée, votre panier et la mémoire des choix faits ici.',
                functional:'Partage sur les réseaux sociaux, recueil d\'avis et autres fonctions de tiers.',
                analytics:'L\'usage du site : nombre de visiteurs, sources de trafic, pages lues.',
                performance:'Mesures de vitesse et de stabilité, pour un site plus rapide et plus fiable.',
                advertisement:'Publicité basée sur les pages consultées, et efficacité des campagnes.',
                other:'Cookies que nous n\'avons pas encore classés.' } },
    sv: { welcome:'Välkommen till by Crea', currency:'Valuta', price:'Pris',
          shipping:'Leveranstid', days:'2–5 dagar', daysSE:'2–3 dagar',
          global:'Internationellt',
          vatEU:'<strong>Moms ingår.</strong> Frakt beräknas i kassan.',
          vatROW:'<strong>Importavgifter, tull och moms ingår.</strong> ' +
                 'Inget tillkommer vid leverans.',
          ptitle:'Vi värnar om din integritet',
          ptext:'Vi använder cookies för att förbättra din upplevelse, anpassa innehåll och ' +
                'analysera trafik. Du kan ändra det när som helst i ' +
                '<a href="/policies/privacy-policy">cookiepolicyn</a>.',
          reject:'Avvisa alla', prefs:'Cookieinställningar', save:'Spara mina val',
          intro:'Nödvändiga cookies håller sajten igång och kan inte stängas av. Allt annat ' +
                'väljer du själv, och du kan ändra dig när du vill.',
          cat:{ necessary:'Säker inloggning, din varukorg och de val du gör här.',
                functional:'Delning till sociala medier, feedback och andra funktioner från tredje part.',
                analytics:'Hur sajten används: antal besökare, trafikkällor, vilka sidor som läses.',
                performance:'Mätning av hastighet och stabilitet, för en snabbare och stabilare sajt.',
                advertisement:'Annonser utifrån sidor du besökt, och om en kampanj gav resultat.',
                other:'Cookies vi ännu inte har klassificerat.' } }
  };

  var ADDRESS = 'Strömgatan 2, 212 25 Malmö, Sweden';
  var PHONE   = '+46 40 12 43 44';
  var VATNR   = 'VAT SE559096957101';
  var CHAT    = { en:'Chat with us', de:'Chatten Sie mit uns',
                  fr:'Discuter avec nous', sv:'Chatta med oss' };

  /* Countries that get their own flag: all of Europe we sell to, plus US/CA/JP/AE.
     Everything else (AU, HK, SG, KR, and anything added later) shows the globe. */
  var EUROPE = ('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO ' +
                'SK SI ES SE CH NO GB JE IS LI').split(' ');
  var FLAGGED = EUROPE.concat(['US','CA','JP','AE']);

  /* Where VAT and duty are already in the price rather than a domestic sale.
     Everything NOT in this list is treated as a domestic EU/EEA sale. */
  var LANDED = ['US','CA','JP','AE','GB','JE','NO','CH','AU','HK','SG','KR'];

  function flagFor(cc) {
    if (FLAGGED.indexOf(cc) === -1) return '🌍';           /* globe */
    return String.fromCodePoint(
      0x1F1E6 + cc.charCodeAt(0) - 65,
      0x1F1E6 + cc.charCodeAt(1) - 65
    );
  }

  /* Country name in the shopper's own language, from the browser. No table. */
  function countryName(cc, locale, t) {
    if (FLAGGED.indexOf(cc) === -1) return t.global;
    try {
      var dn = new Intl.DisplayNames([locale], { type: 'region' });
      return dn.of(cc) || cc;
    } catch (e) { return cc; }
  }

  /* Intl gets most currencies right but renders NOK as "Nkr" and gives AED and CHF
     no symbol at all. These five keep by Crea's own conventions; everything else
     falls through to Intl, so a new currency needs no code change. */
  var SYMBOL = { NOK:'kr', SEK:'kr', DKK:'kr.', CHF:'Fr', AED:'د.إ' };

  function currencyLabel(code, locale) {
    if (!code) return '';
    if (SYMBOL[code]) return code + ' ' + SYMBOL[code];
    try {
      var parts = new Intl.NumberFormat(locale, { style:'currency', currency:code })
        .formatToParts(0);
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'currency' && parts[i].value !== code) {
          return code + ' ' + parts[i].value;
        }
      }
    } catch (e) {}
    return code;
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function factRow(label, value) {
    var li = document.createElement('li');
    li.appendChild(el('span', 'byc-k', label));
    li.appendChild(el('span', null, value));
    return li;
  }

  function build() {
    var S = window.Shopify || {};
    var cc = (S.country || '').toUpperCase();
    var locale = (S.locale || 'en').slice(0, 2).toLowerCase();
    var t = T[locale] || T.en;
    var cur = currencyLabel(S.currency && S.currency.active, locale);

    var root = el('div', 'byc-consent');

    var market = el('div', 'byc-consent__market');
    /* Title first, then the flag row: both column titles share a face and a baseline,
       so the panel reads as one thing (Marcus 2026-10-29). */
    market.appendChild(el('p', 'byc-title', t.welcome + '&reg;'));
    var eyebrow = el('p', 'byc-eyebrow');
    eyebrow.appendChild(el('span', 'byc-eyebrow__flag', flagFor(cc)));
    eyebrow.appendChild(document.createTextNode(countryName(cc, locale, t)));
    market.appendChild(eyebrow);

    var facts = el('ul', 'byc-facts');
    if (cur) facts.appendChild(factRow(t.currency, cur));
    facts.appendChild(factRow(t.price, LANDED.indexOf(cc) > -1 ? t.vatROW : t.vatEU));
    facts.appendChild(factRow(t.shipping, cc === 'SE' ? t.daysSE : t.days));
    market.appendChild(facts);

    var privacy = el('div', 'byc-consent__privacy');
    privacy.appendChild(el('p', 'byc-privacy-title', t.ptitle));
    privacy.appendChild(el('p', 'byc-privacy-text', t.ptext));

    var grid = el('div', 'byc-consent__grid');
    grid.appendChild(market);
    grid.appendChild(el('div', 'byc-consent__rule'));
    grid.appendChild(privacy);
    root.appendChild(grid);

    /* Base strip. The chat link opens our chat drawer in place, and degrades to
       mailto if the widget has not loaded. */
    var dot = function () { var d = el('span', null, '&middot;'); d.setAttribute('aria-hidden','true'); return d; };
    var foot = el('div', 'byc-foot');
    foot.appendChild(el('span', 'byc-addr', ADDRESS));
    foot.appendChild(dot());
    foot.appendChild(el('a', null, PHONE)).setAttribute('href', 'tel:' + PHONE.replace(/\s/g, ''));
    foot.appendChild(dot());
    foot.appendChild(el('span', null, VATNR));
    var chatDot = dot(); chatDot.className = 'byc-dot--chat';
    foot.appendChild(chatDot);

    var chat = el('a', 'byc-chat', CHAT[locale] || CHAT.en);
    chat.setAttribute('href', 'mailto:info@by-crea.com');
    /* Its click (our chat drawer, else mailto) is delegated below, so the server-rendered
       card's link behaves the same (2026-11-02). */
    foot.appendChild(chat);

    root.appendChild(foot);
    var reject = el('button', 'byc-reject', t.reject);
    reject.type = 'button';
    reject.setAttribute('data-byc-consent', 'reject');   /* click delegated below */
    return { root: root, privacy: privacy, reject: reject };
  }

  function texts() {
    var locale = ((window.Shopify || {}).locale || 'en').slice(0, 2).toLowerCase();
    return T[locale] || T.en;
  }

  /* REJECT ALL. Rejecting has to be as easy as accepting. CookieYes's own Reject button
     is switched off in the app, so this goes through CookieYes's own logic instead of
     around it: every optional category switched off in its preference centre, then its
     own Save. If the app's Reject button is ever switched on, that button is used. */
  function rejectAll() {
    var native = document.querySelector('.cky-consent-container .cky-btn-reject, .cky-modal .cky-btn-reject');
    if (native) { native.click(); return; }
    document.querySelectorAll('.cky-modal .cky-switch input[type="checkbox"]').forEach(function (box) {
      if (box.checked) box.click();
    });
    var save = document.querySelector('.cky-modal .cky-btn-preferences');
    if (save) save.click();
  }

  /* The preference centre: CookieYes's title, long description and category texts are
     replaced with ours, Save is renamed, and Reject all is added as the first of three
     equal buttons. Switches, accordions and the cookie tables are CookieYes's own. */
  function dressModal() {
    var modal = document.querySelector('.cky-modal .cky-preference-center');
    if (!modal || modal.getAttribute('data-byc')) return !!modal;
    var t = texts();
    var title = modal.querySelector('.cky-preference-title');
    if (title) title.textContent = t.prefs;
    var desc = modal.querySelector('.cky-preference-content-wrapper');
    if (desc) desc.innerHTML = '<p>' + t.intro + '</p>';
    modal.querySelectorAll('.cky-accordion').forEach(function (acc) {
      var key = (acc.id || '').replace('ckyDetailCategory', '');
      var d = acc.querySelector('.cky-accordion-header-des');
      if (d && t.cat[key]) d.innerHTML = '<p>' + t.cat[key] + '</p>';
    });
    var save = modal.querySelector('.cky-btn-preferences');
    if (save) save.textContent = t.save;
    var wrap = modal.querySelector('.cky-prefrence-btn-wrapper');
    if (wrap && !wrap.querySelector('.cky-btn-reject, .byc-btn-reject')) {
      var r = el('button', 'cky-btn byc-btn-reject', t.reject);
      r.type = 'button';
      r.addEventListener('click', rejectAll);
      wrap.insertBefore(r, wrap.firstChild);
    }
    modal.setAttribute('data-byc', '1');
    return true;
  }

  /* The card's content: the server-rendered shell (snippets/consent-shell.liquid) when the page
     has one, so CookieYes's card is dressed with the very nodes the visitor has been looking at;
     build() otherwise. 2026-11-02. */
  function content() {
    var shell = document.getElementById('byc-consent-shell');
    var root = shell && shell.querySelector('.byc-consent');
    if (!root) return build();
    var btns = root.querySelector('.byc-shell__btns');
    if (btns) btns.remove();
    return { root: root, privacy: root.querySelector('.byc-consent__privacy'), reject: root.querySelector('.byc-reject') };
  }

  function render() {
    var group = document.querySelector('.cky-consent-container .cky-notice-group');
    if (!group) return false;
    if (group.querySelector('.byc-consent')) return true;

    var built = content();

    /* CookieYes's copy is replaced; its BUTTONS are MOVED, never rebuilt, so every
       handler CookieYes bound stays attached and the consent logic is untouched. */
    var box = document.querySelector('.cky-consent-container');
    (box || group).querySelectorAll('.cky-title, .cky-notice-des').forEach(function (n) {
      /* Scoped to the CONTAINER, not the notice group: CookieYes renders a second
         .cky-title above the group, which left "We value your privacy" printed
         twice - once as a stray heading, once inside our privacy column. */
      if (!n.closest('.byc-consent')) n.remove();
    });

    var buttons = document.querySelector('.cky-consent-container .cky-notice-btn-wrapper');
    group.insertBefore(built.root, group.firstChild);
    /* Reject all sits ABOVE the buttons, left aligned (Alexander 2026-10-31). */
    built.privacy.appendChild(built.reject);
    if (buttons) built.privacy.appendChild(buttons);
    return true;
  }

  /* Reveal the card exactly once, at its final size. See the CLS note in the CSS.
     Called on success, on give-up, and on a hard timeout, so the banner can never be
     left invisible: consent must always be reachable even if the rebuild fails. */
  function reveal() {
    var box = document.querySelector('.cky-consent-container');
    /* Only when missing: classList.add rewrites the attribute even when the class is there, and
       the class observer below would then call tick() -> reveal() forever. */
    if (box && !box.classList.contains('byc-ready')) box.classList.add('byc-ready');
  }

  /* ---------- the server-rendered shell (2026-11-02) ----------
     The shell is the card from the first frame until CookieYes shows its own; then the
     shell's content is moved into CookieYes's card (render) and the shell is dropped, in one
     task, so the swap cannot be seen. A shell click before that waits for CookieYes. */
  var html = document.documentElement;
  var pending = window.__bycConsentPending || null;
  window.__bycConsentLive = true;

  function shellShowing() {
    return !!document.getElementById('byc-consent-shell') && html.classList.contains('byc-shell-on');
  }
  function dropShell() {
    var shell = document.getElementById('byc-consent-shell');
    if (shell) shell.remove();
    html.classList.remove('byc-shell-on');
  }
  /* Which shell control has keyboard focus, read BEFORE its nodes move or go. */
  function shellFocus() {
    var shell = document.getElementById('byc-consent-shell'), a = document.activeElement;
    return shell && a && shell.contains(a) ? a.getAttribute('data-byc-consent') : null;
  }
  /* Keyboard users keep their place: focus moves to the same control on CookieYes's card. */
  function refocus(action) {
    var sel = action === 'accept' ? '.cky-consent-container [data-cky-tag="accept-button"]'
      : action === 'settings' ? '.cky-consent-container [data-cky-tag="settings-button"]'
      : '.cky-consent-container .byc-reject';
    var n = action && document.querySelector(sel);
    if (n) n.focus({ preventScroll: true });
  }
  /* CookieYes is ready once its own Accept button exists. */
  function ready() {
    return !!document.querySelector('.cky-consent-container [data-cky-tag="accept-button"]');
  }
  /* Every choice is made by CookieYes's OWN control, so the cookie, its consent log and its
     Google consent-mode update are exactly what they were before the shell existed. */
  function perform(action) {
    if (render()) reveal();
    dropShell();
    if (action === 'reject') { rejectAll(); return; }
    var n = document.querySelector('.cky-consent-container [data-cky-tag="' +
      (action === 'settings' ? 'settings-button' : 'accept-button') + '"]');
    if (n) n.click();
  }

  function tick() {
    var box = document.querySelector('.cky-consent-container');
    var done = false;
    /* While the shell is the card, CookieYes's card is only dressed once CookieYes shows it:
       moving the content earlier would empty the shell while nothing else is on screen. */
    if (!shellShowing() || (box && !box.classList.contains('cky-hide'))) {
      var focused = shellFocus();
      done = render();
      if (done) {
        reveal();
        if (shellShowing()) { dropShell(); refocus(focused); }
      }
    }
    var dressed = dressModal();
    if (pending && ready()) {
      var a = pending;
      pending = null;
      perform(a);
    }
    return { done: done, dressed: dressed };
  }

  /* Delegated: the shell's buttons, the Reject link wherever it now sits, the chat link. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var chat = t.closest('.byc-consent .byc-chat');
    if (chat) {
      /* 2026-10-03 (B2B did the same 2026-10-02): this used to hunt for
         Gorgias/Tidio/Intercom launchers, none of which by Crea runs, so it
         always fell back to mailto. Our own drawer answers directly. */
      if (window.byCreaChat && window.byCreaChat.open) {
        e.preventDefault(); window.byCreaChat.open();
      }
      return;
    }
    var b = t.closest('[data-byc-consent]');
    if (!b) return;
    e.preventDefault();
    var action = b.getAttribute('data-byc-consent');
    if (ready()) { perform(action); return; }
    pending = action;
    b.setAttribute('aria-busy', 'true');
  });

  var tries = 0;
  var timer = setInterval(function () {
    var r = tick();
    tries++;
    /* The banner is revealed as soon as it is built; the poll keeps going only until the
       preference centre is dressed too, with the same ~10s ceiling for both. */
    if (r.done || tries > 50) reveal();
    if ((r.done && r.dressed) || tries > 50) clearInterval(timer);
  }, 200);

  /* Without waiting for the poll: CookieYes inserts its markup at the top of <body> and shows
     its card by removing .cky-hide; both are watched so the hand-over happens in that frame. */
  var watched = null;
  function watch() {
    var box = document.querySelector('.cky-consent-container');
    if (box && box !== watched) {
      watched = box;
      new MutationObserver(tick).observe(box, { attributes: true, attributeFilter: ['class'] });
    }
    tick();
  }
  if (document.body) new MutationObserver(watch).observe(document.body, { childList: true });
  document.addEventListener('cookieyes_banner_load', watch);
  watch();

  /* Failsafe: whatever happens above, show the card after 3s. */
  setTimeout(reveal, 3000);

  /* CookieYes never arrived (blocked by an ad blocker, or down): drop the shell, which is what
     visitors saw before it existed - no card. Generous on slow phones: 8 s after load without
     its script, 20 s with the script but no card. */
  function giveUp() {
    if (!shellShowing() || document.querySelector('.cky-consent-container')) return;
    dropShell();
  }
  function afterLoad() {
    setTimeout(function () { if (!window.cookieyes) giveUp(); }, 8000);
    setTimeout(giveUp, 20000);
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad);
})();
